import padStart from 'lodash/padStart'
import React from 'react'
import { Icon, IconText } from '@components/UI'

import {
  useRecordingPlaybackState,
  useRecordingPlaybackStateObserver
} from '../../hooks'
import { Seeker } from './Seeker'

const RecordingControls = () => {
  const { elapsed, total } = useNormalizedRecordingPlaybackTime()
  const { status, loading } = useRecordingPlaybackState()
  const playbackStateObserverRef = useRecordingPlaybackStateObserver()

  const getPlayButtonIconName = () => {
    if (loading) return 'loading spinner'
    return status === 'IDLE' ? 'play' : 'pause'
  }

  return (
    <footer>
      <div
        className='communication-controls-container'
        style={{ justifyContent: 'flex-start', paddingLeft: 0 }}
      >
        <button
          className='ui gp-button interactive circular-btn active'
          onClick={() => {
            if (loading) return

            status === 'IDLE'
              ? playbackStateObserverRef.current.play()
              : playbackStateObserverRef.current.pause()
          }}
        >
          <Icon name={getPlayButtonIconName()} />
        </button>

        <button
          className='ui gp-button interactive circular-btn active'
          onClick={() => {
            playbackStateObserverRef.current.stop()
          }}
        >
          <Icon name='stop fill' />
        </button>
        <div className='ui gp-box box-a4'>
          {elapsed.min}:{elapsed.sec} / {total.min}:{total.sec}
        </div>

        <Seeker />
      </div>

      <div className='settings-container'>
        <button className='ui gp-button gp-box box-a4 interactive help-button'>
          <IconText value='Help' icon='question mark' group='a2' />
        </button>
      </div>
    </footer>
  )
}

const useNormalizedRecordingPlaybackTime = () => {
  const { elapsed, genesis, terminus } = useRecordingPlaybackState()

  const normalizeMS = (ms) => {
    const minutes = Math.floor(ms / 1000 / 60)
    const seconds = Math.floor((ms / 1000) % 60)

    return {
      min: padStart(minutes.toString(), 2, '0'),
      sec: padStart(seconds.toString(), 2, '0')
    }
  }

  const total = normalizeMS(terminus - genesis)
  const normalizedElapsed = normalizeMS(elapsed)

  return {
    elapsed: normalizedElapsed,
    total
  }
}

export default RecordingControls
